export enum StatusCode {
    MovedPermanently = '301',
    Found = '302',
    TemporaryRedirect = '307',
    PermanentRedirect = '308',
}
